// extracted by mini-css-extract-plugin
module.exports = {"block":"block--Xu1xB","block_selected":"block_selected--EW8fC","name":"name--1uedD","tag":"tag--W14zJ","date":"date--xue-U"};